<template>
  <div class="all-style-bgc">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoreportInternet">清风论坛></span>
        <span @click="GoreportEvaluation">亦廉课堂></span>
        <span @click="GoreportOutside">武装自己></span>
        <span class="red">正文</span>
      </div>
      <!--正文内容-->
      <div class="text">
        <h1>至诚报国，像战士一样坚守</h1>
        <h2>
          来源：新华社
          <span class="mg-16">|</span>
          发布时间：2020-03-30&nbsp;13:30
        </h2>
        <h3>随着密集、持久的新闻报道，更多的人深入地了解到黄大年的先进事迹，感动、感悟着他身上特有的那股精气神——</h3>

        <h3>黄大年拥有物理学家、教授、博导等诸多头衔，获得过诸多荣誉，但他最喜欢的称呼是“战士”。当然，就他的作用而言，绝非一名普通战士可比，“他的回国，让某国航母演习整个舰队后退100海里”，就足以说明一切。</h3>
        <h3>黄大年常把人生比作战场，把自己当作战士。在谈到深地探测的关键装备时，他忧虑地说“人家是导弹部队，我们还是‘小米加步枪’啊”；在自认为和他关系不错的专家来找他“拉点儿经费”时，他严肃地说“我只有国家利益”；在听到“受伤要下火线”的劝阻时，他坦然地说“我是活一天赚一天，哪天倒下，就地掩埋”；即将动手术的前一夜，他无畏地说“无论什么样的战斗都有一个共性——大战前夕最寂静，静得像平安夜”……他的赤诚、他的胆识、他的心胸，多像一名“感时思报国，拔剑起蒿莱”的战士。黄大年以战士自喻，也以战士自励，以战士本色带出了敢打硬仗的科研团队，也拥有了无往不胜的赫赫战果。</h3>
        <h3>黄大年英年早逝，却留给我们无尽的思考：价值多元的时代，每个人都可以自主地选择自己的活法，崇尚不同的观念，但总有一些价值需要坚守，比如家国情怀、战士本色、社会责任等。也只有这些主流价值，才能“像灯塔一样，为一切夜里不能航行的人，用火光把道路照明”。相反，精致的利己主义、庸俗的功利交换、潇洒的看客心态，成就不了出彩的人生，更支撑不起民族复兴的大厦。</h3>
        <h3>战士本色是忠诚。心有大我，至诚报国。在黄大年的心里，祖国需要就是最高追求，为国担当就是人生信条。从立下“振兴中华，乃我辈之责”的远大志向，到响应国家“千人计划”的召唤毅然归国；从带领科研团队创造多项“中国第一”，到为祖国潜心培养一批后起之秀，黄大年真正实现了“只要祖国需要，我必全力以赴”的誓言。“得其大者可以兼其小。”黄大年的人生选择告诉我们，一个人只有把个人梦与中国梦紧密联系在一起，与祖国相连、与大地相依，个体奋斗的价值才能得到升华。</h3>
        <h3>战士本色是拼搏。科技领域的竞争如逆水行舟，不创新不行，创新慢了也不行。“一个真正的科学家总会有极其强大的不安全感，生怕自己稍微慢一步就落下了。”黄大年正是怀着这样的忧患意识和强烈紧迫感，以只争朝夕的精神，像陀螺一样不知疲倦地旋转，为科技创新抢时间、赶进度。“科研疯子”“拼命黄郎”……透过这样的绰号，人们读懂了一个科学家矢志创新、砥砺奋进的拼搏精神和远大抱负。</h3>
        <h3>战士本色是平凡。战士本色是去掉浮名后自自然然的真我，是行程万里仍笃定不移的初心。苔花如米小，也学牡丹开。黄大年不要什么行政职务，不搞什么个人投资，甚至连申请院士也忙得没时间，但他把对祖国的挚爱、对科研的执着，定格成为忙碌的身影、长明的灯光和辉煌的成绩。</h3>
        <h3>实现国家由大到强的“关键一跃”，需要千千万万个像黄大年这样脚踏实地的行动者和默默耕耘的奉献者！（辛士红）</h3>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      PicBannertest1: require("../../../../assets/image/wzzj1-1.jpg"),
      PicBannertest2: require("../../../../assets/image/wzzj3-1.jpg")
    };
  },
  methods: {
    GoreportInternet() {
      this.$router.push("/forum");
    },
    GoreportEvaluation() {
      this.$router.push({ name: "forumClassroom" });
    },
    GoreportOutside() {
      this.$router.push({ name: "forumOutside" });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
/*副导航兰*/
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
/*问卷调查正文*/
.text {
  background-color: white;
  padding: 44px 60px 121px 60px;
  margin: 0 auto;
}
.text h1 {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 56px;
  text-align: center;
}
.text h2 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 44px;
  text-align: center;
  padding-bottom: 14px;
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 15px;
   text-align: center;
  display: flex;
  justify-content: center;
}
.text h3 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  text-indent: 2em;
  margin-bottom: 30px;
}
/*静态页面样式 */
.PIC-BOX {
  display: flex;
  justify-content: center;
}
img {
  margin: 20px 0;
}
.mg-16{
  margin: 0px 16px;
}
</style>